module.exports = __webpack_public_path__ + "img/pwmat-mlff.d8d4bcec.jpg";